/* Gössl 2026 — behaviours for the g26 components: nav open states, sliders,
   cart trigger. Dependency-free; runs after DOMContentLoaded (script is deferred). */
(function () {
  "use strict";
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Nav: desktop panels on hover + focus, mobile overlay + accordion */
  var nav = $("[data-g26-nav]");
  if (nav) {
    var items = $$(".g26-nav__item.has-panel", nav);
    var closeAll = function (except) { items.forEach(function (it) { if (it !== except) { it.classList.remove("is-open"); var l = $(".g26-nav__link", it); if (l) l.setAttribute("aria-expanded", "false"); } }); };
    items.forEach(function (it) {
      var link = $(".g26-nav__link", it), t, warmed = false;
      /* prewarm: fetch+decode the panel's lazy images on hover intent so the
         content-visibility gate doesn't cause a burst on first open */
      var warm = function () {
        if (warmed) return; warmed = true;
        $$("img", $(".g26-nav__panel", it)).forEach(function (img) {
          if (img.decode) { img.decode().catch(function () {}); }
        });
      };
      var open = function () { clearTimeout(t); closeAll(it); warm(); it.classList.add("is-open"); link.setAttribute("aria-expanded", "true"); };
      var close = function () { t = setTimeout(function () { it.classList.remove("is-open"); link.setAttribute("aria-expanded", "false"); }, 120); };
      it.addEventListener("pointerenter", warm);
      it.addEventListener("mouseenter", open); it.addEventListener("mouseleave", close);
      /* r33 a11y: no auto-open on focus - keyboard users tab past ~8 top-level
         stops; ArrowDown or Space opens the panel deliberately */
      /* e.target.disabled: an arrow that just reached the end of its rail drops focus, which must not close the panel (SJ 02.11.2026) */
      it.addEventListener("focusout", function (e) { if (!it.contains(e.relatedTarget) && !e.target.disabled) close(); });
      link.addEventListener("keydown", function (e) {
        if (e.key === "ArrowDown" || e.key === " ") { e.preventDefault(); open(); var f = $(".g26-nav__panel a", it); if (f) f.focus(); }
      });
      link.addEventListener("click", function (e) { if (window.matchMedia("(hover: none)").matches && !it.classList.contains("is-open")) { e.preventDefault(); open(); } });
    });
    /* Escape: restore focus to the open item's link before closing, so Tab
       doesn't restart from the top of the document */
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var openItem = items.filter(function (it) { return it.classList.contains("is-open"); })[0];
      if (openItem && openItem.contains(document.activeElement)) { var l = $(".g26-nav__link", openItem); if (l) l.focus(); }
      closeAll();
    });
    /* touch: tapping outside the nav closes an open panel (mouseleave never fires) */
    document.addEventListener("pointerdown", function (e) { if (!nav.contains(e.target)) closeAll(); }, { passive: true });
    var burger = $("[data-g26-burger]", nav), mobile = $("[data-g26-mobile]", nav);
    if (burger && mobile) {
      var pageInert = function (on) {
        $$("main, [role='main'], .g26-footer, footer").forEach(function (el) {
          if (on) el.setAttribute("inert", ""); else el.removeAttribute("inert");
        });
      };
      /* a11y #902: the open menu covers the page, so it behaves like the other overlays (assets/global.js):
         Tab cycles through the header bar and the menu (the burger that closes it stays reachable), focus
         starts on the first menu entry, Escape closes, and focus goes back to the burger */
      var menuOverlay = null;
      var setMenu = function (open) {
        burger.setAttribute("aria-expanded", open ? "true" : "false");
        if (open) mobile.removeAttribute("hidden"); else mobile.setAttribute("hidden", "");
        document.body.classList.toggle("g26-menu-open", open);
        pageInert(open);
        if (!menuOverlay && window.Goessl && window.Goessl.overlayFocus) {
          menuOverlay = window.Goessl.overlayFocus(nav, {
            onEscape: function () { setMenu(false); },
            initialFocus: function () { return $("a[href], button", mobile); },
            fallback: function () { return burger; }
          });
        }
        if (menuOverlay) { if (open) menuOverlay.open(burger); else menuOverlay.close(); }
        else if (!open) burger.focus();
      };
      burger.addEventListener("click", function () { setMenu(burger.getAttribute("aria-expanded") !== "true"); });
      $$("[data-g26-acc]", mobile).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var sub = btn.nextElementSibling, open = btn.getAttribute("aria-expanded") === "true";
          btn.setAttribute("aria-expanded", open ? "false" : "true");
          if (sub) { if (open) sub.setAttribute("hidden", ""); else sub.removeAttribute("hidden"); }
        });
      });
    }
    var cartLink = $("[data-g26-cart-open]", nav);
    if (cartLink) cartLink.addEventListener("click", function (e) {
      if (document.querySelector("[data-cart-drawer]")) { e.preventDefault(); document.dispatchEvent(new CustomEvent("cart:open")); }
    });
  }

  /* Generic drawers (filter drawer etc.): [data-g26-drawer-open=name] toggles [data-g26-drawer=name] */
  $$("[data-g26-drawer-open]").forEach(function (btn) {
    var name = btn.getAttribute("data-g26-drawer-open"), dr = document.querySelector('[data-g26-drawer="' + name + '"]');
    if (!dr) return;
    /* a11y #902: the shared overlay behaviour (assets/global.js) - focus moves to the panel's first
       control, Tab stays in the panel, Escape closes, and focus goes back to the button */
    var overlay = null;
    var open = function () {
      dr.removeAttribute("hidden"); btn.setAttribute("aria-expanded", "true"); document.body.classList.add("g26-drawer-open");
      if (!overlay && window.Goessl && window.Goessl.overlayFocus) overlay = window.Goessl.overlayFocus($('[role="dialog"]', dr) || dr, { onEscape: close, fallback: function () { return btn; } });
      if (overlay) overlay.open(btn); else { var f = $("input:not([disabled]), button, select", dr); if (f) f.focus(); }
    };
    var close = function () {
      dr.setAttribute("hidden", ""); btn.setAttribute("aria-expanded", "false"); document.body.classList.remove("g26-drawer-open");
      if (overlay) overlay.close(); else btn.focus();
    };
    btn.addEventListener("click", open);
    $$("[data-g26-drawer-close]", dr).forEach(function (c) { c.addEventListener("click", close); });
  });
  /* Facet form: drop empty fields + default sort so shared URLs stay clean.
     #171: a size selection also sends filter.v.availability=1, so Shopify
     itself drops sold-out-in-that-size products — pagination and facet
     counts then match the grid (the Liquid size_ok check stays as backstop). */
  var facetForm = document.getElementById("g26-facets");
  if (facetForm) facetForm.addEventListener("submit", function () {
    var sizeChecked = facetForm.querySelector('input[type="checkbox"][name^="filter.v.option.gr"]:checked');
    var av = facetForm.querySelector('input[name="filter.v.availability"]');
    if (sizeChecked && !av) {
      av = document.createElement("input");
      av.type = "hidden"; av.name = "filter.v.availability"; av.value = "1";
      facetForm.appendChild(av);
    }
    if (av) av.disabled = !sizeChecked;
    Array.prototype.forEach.call(facetForm.elements, function (el) {
      if ((el.type === "number" || el.type === "text") && el.value.trim() === "") el.disabled = true;
      if (el.name === "sort_by" && el.getAttribute("data-default") && el.value === el.getAttribute("data-default")) el.disabled = true;
    });
  });
  $$("[data-g26-autosubmit]").forEach(function (sel) {
    sel.addEventListener("change", function () {
      var f = sel.form || document.getElementById(sel.getAttribute("form"));
      if (!f) return;
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
    });
  });
  /* #171 guard: availability without a size (chip-removed last size, shared
     URL) would silently thin unfiltered pages — reload once without it. */
  if (facetForm && /[?&]filter\.v\.availability=/.test(location.search) && !/filter\.v\.option\.gr/.test(location.search)) {
    var cleaned = location.search.replace(/([?&])filter\.v\.availability=[^&]*&?/, "$1").replace(/[?&]$/, "");
    location.replace(location.pathname + cleaned + location.hash);
  }

  /* Sliders: arrows scroll by one card, disabled at the ends.
     One shared debounced resize listener updates every slider (instead of one
     unthrottled listener per instance). */
  var sliderUpdates = [];
  function g26InitSlider(s) {
    var track = $("[data-g26-track]", s), prev = $("[data-g26-prev]", s), next = $("[data-g26-next]", s);
    if (!track) return;
    var step = function () { var it = $(".g26-slider__item", track); return it ? it.getBoundingClientRect().width + 20 : 300; };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    track.addEventListener("scroll", update, { passive: true });
    sliderUpdates.push(update); update();
  }
  $$("[data-g26-slider]").forEach(g26InitSlider);
  window.g26InitSlider = g26InitSlider;
  if (sliderUpdates.length) {
    var rt;
    window.addEventListener("resize", function () {
      clearTimeout(rt);
      rt = setTimeout(function () { sliderUpdates.forEach(function (u) { u(); }); }, 150);
    });
  }
})();


/* ── Mein Gwandhaus (r68, SJ 26.08) ──────────────────────────────────
   ONE favourite store, storefront-wide: the availability modal, the
   Geschäfte page stars, the location pages and the PDP store line all
   read/write goessl:favStore (page slug). Buttons carry data-fav-store
   with the page link or slug; binding is delegated so late-rendered
   stars (map popovers, A-Z reorder) need no re-init. */
(function () {
  var KEY = 'goessl:favStore';
  function favGet() { try { return localStorage.getItem(KEY) || null; } catch (e) { return null; } }
  function favSet(v) { try { if (v) localStorage.setItem(KEY, v); else localStorage.removeItem(KEY); } catch (e) {} }
  function slugOf(btn) {
    return String(btn.dataset.favStore || '').replace(/^\/pages\//, '').replace(/[^a-z0-9-]/gi, '');
  }
  function paint() {
    var fav = favGet();
    document.querySelectorAll('[data-fav-store]').forEach(function (b) {
      var on = !!fav && slugOf(b) === fav;
      b.classList.toggle('is-fav', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? window.g26t('sections.store_locator.favourite_unset', 'Nicht mehr mein Gwandhaus') : window.g26t('sections.store_locator.favourite_set', 'Als mein Gwandhaus wählen');
      b.setAttribute('aria-label', label);
      b.title = label;
    });
    document.dispatchEvent(new CustomEvent('favstore:change', { detail: { fav: fav } }));
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav-store]');
    if (!b) return;
    e.preventDefault();
    var s = slugOf(b);
    if (!s) return;
    favSet(favGet() === s ? null : s);
    paint();
  });
  window.GoesslFavStore = { get: favGet, set: function (v) { favSet(v); paint(); }, paint: paint };
  if (document.readyState !== 'loading') paint();
  else document.addEventListener('DOMContentLoaded', paint);
})();

/* Video strip (#191): lazy, in-view-only playback for the quiet portrait
   loops. The src is applied only when a tile approaches the viewport
   (preload=none + poster until then); playback runs only while visible.
   prefers-reduced-motion never autoplays — the poster stands in. */
function g26ObserveVideos(root) {
  var vids = (root || document).querySelectorAll("video[data-g26-video]");
  if (!vids.length) return;
  if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (!window.__g26VideoIO) {
    window.__g26VideoIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.getAttribute("src")) v.src = v.getAttribute("data-src");
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (v.getAttribute("src")) {
          v.pause();
        }
      });
    }, { rootMargin: "30% 0px", threshold: 0.1 });
  }
  vids.forEach(function (v) { if (!v.__g26Observed) { v.__g26Observed = true; window.__g26VideoIO.observe(v); } });
}
g26ObserveVideos();
window.g26ObserveVideos = g26ObserveVideos;

/* r164: collection "Mehr laden" (14.09.2026) — appends the next page's cards via the Section Rendering API.
   The button is a plain link to the next page, so it keeps working without JS; on any error it navigates.
   r165 (15.09.2026, Felix): coming BACK from a product restores the loaded pages and the scroll position.
   State per collection URL lives in sessionStorage ({ pages, y }); the restore runs only on back/forward
   navigations that were not served from the bfcache (a bfcache restore keeps DOM and scroll by itself). */
(function () {
  var KEY = 'g26more:' + location.pathname + location.search;
  var MAX_PAGES = 30;
  var pages = parseInt(new URL(location.href).searchParams.get('page') || '1', 10) || 1; // highest page in the DOM

  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify({ pages: pages, y: window.scrollY || window.pageYOffset || 0, t: Date.now() })); } catch (_) {}
  }
  function pageUrl(n, sectionId) {
    var url = new URL(location.href);
    url.hash = '';
    url.searchParams.set('page', String(n));
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }
  function append(html, fallbackHref) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var grid = document.querySelector('#g26-collection .g26-grid');
    var newGrid = doc.querySelector('.g26-grid');
    var nav = document.querySelector('[data-g26-more-nav]');
    var newNav = doc.querySelector('[data-g26-more-nav]');
    if (!grid || !newGrid) { if (fallbackHref) location.href = fallbackHref; return null; }
    var items = Array.prototype.slice.call(newGrid.children).filter(function (li) {
      return li.classList.contains('g26-grid__item') && !li.classList.contains('g26-grid__item--span');
    });
    items.forEach(function (li) { grid.appendChild(li); });
    if (nav) {
      if (newNav) { nav.innerHTML = newNav.innerHTML; bind(nav); } else { nav.remove(); }
    }
    pages += 1;
    if (window.g26ObserveVideos) window.g26ObserveVideos();
    document.dispatchEvent(new CustomEvent('g26:cards-added', { detail: { count: items.length } }));
    return items;
  }
  function bind(scope) {
    var btn = (scope || document).querySelector('[data-g26-more]');
    if (!btn || btn.__g26More) return;
    btn.__g26More = true;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      var href = btn.getAttribute('href').split('#')[0];
      var url = new URL(href, location.origin);
      url.searchParams.set('section_id', btn.dataset.sectionId || '');
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var items = append(html, href);
          if (items && items[0]) { var a = items[0].querySelector('a'); if (a) { try { a.focus({ preventScroll: true }); } catch (_) {} } }
          save();
        })
        .catch(function () { location.href = href; });
    });
  }
  function restore() {
    var state = null;
    try { state = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (_) {}
    if (!state || !(state.pages > pages || state.y > 0)) return;
    var entry = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (!entry || entry.type !== 'back_forward') return;
    var btn = document.querySelector('[data-g26-more]');
    var sectionId = btn ? (btn.dataset.sectionId || '') : '';
    var target = Math.min(state.pages, MAX_PAGES);
    try { history.scrollRestoration = 'manual'; } catch (_) {}
    function finish() {
      window.scrollTo(0, state.y || 0);
      requestAnimationFrame(function () { window.scrollTo(0, state.y || 0); });
      save();
    }
    function next() {
      if (pages >= target || !document.querySelector('[data-g26-more]')) { finish(); return; }
      fetch(pageUrl(pages + 1, sectionId), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) { if (append(html, null)) next(); else finish(); })
        .catch(finish);
    }
    if (target > pages && sectionId) next(); else finish();
  }
  function init() {
    bind(document);
    restore();
    window.addEventListener('pagehide', save);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
